import styles from './FrameworkOverlay.module.css';

/** The rendering stack a page was served by — the label shown by the overlay. */
export type Framework = 'RRv7' | 'Astro';

interface FrameworkOverlayProps {
  framework: Framework;
}

/**
 * Developer debug overlay shared by RR7 atlas and atlas-astro (NGF-6389). A tiny fixed badge pinned to
 * the top-left of the viewport showing which stack served the page — `RRv7` or `Astro`. Activated
 * per-request by the `overlay-framework: true` header; both apps gate it on
 * `genericConfig.showFrameworkOverlay` and pass their own `framework` label. Purely presentational
 * (no state, no host context), so Astro renders it as static HTML (no client directive) and RR7
 * renders it directly — single source of truth (see apps/atlas-astro/CLAUDE.md).
 */
export function FrameworkOverlay({ framework }: FrameworkOverlayProps) {
  return (
    <div className={styles.overlay} data-framework={framework} data-testid="framework-overlay">
      {framework}
    </div>
  );
}
